import { render, staticRenderFns } from "./RewardStatus.vue?vue&type=template&id=5d96e81a&"
import script from "./RewardStatus.vue?vue&type=script&lang=js&"
export * from "./RewardStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports